import { render, staticRenderFns } from "./DetailController.vue?vue&type=template&id=f81793a6"
import script from "./DetailController.vue?vue&type=script&lang=js"
export * from "./DetailController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports